(function() {
    'use strict';

    var angular:angular.IAngularStatic =  require('angular');
    angular.module('prmTranslate')
        .factory('prmInterpolation', PrmInterpolation);

    function PrmInterpolation($interpolate, prmTranslationIdToCodeMapping) {

        let $locale;

        return {
            setLocale: function(locale) {
                $locale = locale;
            },

            getInterpolationIdentifier: function() {
                return 'custom';
            },

            interpolate: function(string, interpolateParams) {
                interpolateParams = interpolateParams || {};

                function translateCode(placeholder) {
                    let code = placeholder.code;

                    if (!('prefix' in placeholder)) {
                        return code;
                    }

                    let prefix = placeholder.prefix;

                    let translationId;
                    if (prefix) {
                        translationId = prefix + '.' + code;
                    } else {
                        translationId = code;
                    }
                    prmTranslationIdToCodeMapping.setMapping(translationId, code);

                    if (placeholder.tag) {
                        let tag = Object.keys(placeholder.tag)[0];
                        return '<' + tag + ' ' + placeholder.tag[tag].join(' ') +
                            '" translate="' + translationId + '"></' + tag + '>';
                    } else {
                        return '<span class="' + placeholder.cssClass + '" translate="' + translationId + '"> </span>';
                    }
                }

                function replacePlaceHolder(match, p1) {
                    let placeholder = interpolateParams.placeholders[p1];

                    let allTranslationsValues = placeholder.map(translateCode).join(' ');
                    return allTranslationsValues;

                }

                if (interpolateParams.placeholders && string.search(/\{(\d+)}/) > -1) {

                    let newString = string.replace(/\{(\d+)}/g, replacePlaceHolder);
                    return $interpolate(newString)(interpolateParams);
                } else if(string.includes('{{')) {
                    try {
                        return $interpolate(string)(interpolateParams);
                    }catch(err){
                        //in case an interpolation fails (when a translation has {{}} that is not a parameter
                        // dont crash the entire application
                        return string;
                    }
                }
                else {
                    return string;
                }

            }

        };

    }
    PrmInterpolation.$inject = ['$interpolate', 'PrmTranslationIdToCodeMapping'];

})();



// WEBPACK FOOTER //
// ./src/main/webapp/components/translate/prmTranslatePlaceholder.factory.ts